const ProhibitedStates = ['CA', 'GA', 'KY', 'LA', 'OH', 'OR'];
export default ProhibitedStates;



// WEBPACK FOOTER //
// ./src/data/static/reinvestProhibitedStates.js